"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSearchPreviewProductToShadePicker = void 0;
const mapSearchPreviewProductToShadePicker = product => product.shades?.map(shade => ({
  code: shade.productCode,
  name: shade.name ?? '',
  price: {
    currentFormatted: shade.price?.currentFormatted ?? '',
    oldFormatted: shade.price?.oldFormatted ?? ''
  },
  shade
})) ?? [];
exports.mapSearchPreviewProductToShadePicker = mapSearchPreviewProductToShadePicker;
//# sourceMappingURL=mapSearchPreviewProductToShadePicker.js.map